<template>
  <div id="top">
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner"></div>
    </div>
    <OrganismsLayoutsDialog />
    <OrganismsLayoutsDailyPopup />
    <OrganismsLayoutsHeader />
    <slot />
    <!-- サポート導線の4コンテンツ（定期コース特典・定期FAQ・お買い物サポート・お問い合わせ）は
         全ページ共通ではなくルートごとに載せる載せないが決まるので、chrome ではなくページ側に置く。
         → `OrganismsSupport` と CONVERSION-GUIDE §6「サポート導線4コンテンツ」の要13ルート -->
    <PartsLayoutContainer>
      <!-- `sp-only` は支給CSSのクラス名。`.sidebar.sp-only` に限っては 1000px 以下で表示される（SP専用ではない） -->
      <OrganismsLayoutsSidebar sp-only />
    </PartsLayoutContainer>
    <OrganismsLayoutsFooter />
  </div>
</template>

<script setup lang="ts">
const { isLoading } = useLoadingState();
const { canonicalUrlState, setCanonicalUrlState } = useCanonical();
const route = useRoute();

watch(
  () => route.path,
  (newPath: string) => {
    setCanonicalUrlState(newPath);
  },
  { immediate: true }
);
// **`watch` の中で `useHead` を呼ばない。** 値が空になっても登録済みのタグを取り下げられず、
// canonical を出さないページでも前のページのものが残る。`computed` を渡せば追従する。
useHead({
  link: computed(() =>
    canonicalUrlState.value ? [{ rel: 'canonical', href: canonicalUrlState.value }] : []
  ),
});

onMounted(() => {
  // Marketing Cloudメール配信CVタグの入口タグ
  function setCookie(name: string, value: string, numberOfDays: number) {
    const days: number = numberOfDays && numberOfDays > 0 ? numberOfDays : 1;
    const maxAge: number = days * 24 * 60 * 60;
    document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAge}; path=/`;
  }

  const ExpireDays: number = 90;
  const queryString: string = document.location.search;
  const queryStringWithoutQuestion: string = queryString.startsWith('?')
    ? queryString.substring(1)
    : '';
  const queryParamsArray: string[] = queryStringWithoutQuestion.split('&');

  queryParamsArray.forEach((param: string) => {
    const [key, value] = param.split('=');
    switch (key) {
      case 'sfmc_sub':
        setCookie('SubscriberID', value, ExpireDays);
        break;
      case 'e':
        setCookie('EmailAddr_', value, ExpireDays);
        break;
      case 'j':
        setCookie('JobID', value, ExpireDays);
        break;
      case 'l':
        setCookie('ListID', value, ExpireDays);
        break;
      case 'jb':
        setCookie('BatchID', value, ExpireDays);
        break;
      case 'u':
        setCookie('UrlID', value, ExpireDays);
        break;
      case 'mid':
        setCookie('MemberID', value, ExpireDays);
        break;
      default:
        break;
    }
  });
});
</script>

<style scoped>
/* 画面全体を覆うオーバーレイ */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* 半透明の背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* 他の要素より前面に表示 */
}

/* スピナー（CSSだけで実装） */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3; /* ライトグレーの枠 */
  border-top: 5px solid #3498db; /* 青色のローディング部分 */
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
